import { Box } from "@mui/material";
import { FC } from "react";

interface AdvanceProps {
    advanceAmount: number;
    accountNumber?: string;
    daysToPay: number;
    paymentDate: string | 0;
}

// Dodaj styl globalny dla druku bezpośrednio w pliku
const printStyle = `
@media print {
  .page-break {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
`;

if (typeof document !== "undefined") {
    const style = document.createElement("style");
    style.innerHTML = printStyle;
    document.head.appendChild(style);
}

const Advance: FC<AdvanceProps> = ({
    advanceAmount,
    accountNumber = "05 9226 0005 0023 6003 2000 0010",
    daysToPay,
    paymentDate,
}) => {
    return (
        <Box
            className="page-break"
            sx={{
                width: "100%",
                maxWidth: 340,
                background: "#fff",
                color: "#111",
                borderRadius: 2,
                padding: "18px 20px",
                marginLeft: "auto",
                display: "flex",
                flexDirection: "column",
                fontSize: 15,
            }}
        >
            {/* <Box>
                Zaliczka: <strong>{advanceAmount} PLN</strong>
            </Box> */}
            <Box>
                Konto: <strong>{accountNumber}</strong>
            </Box>
            <Box>
                Termin: <strong>{daysToPay} dni</strong>
            </Box>
            <Box>
                Data płatności: <strong>{paymentDate}</strong>
            </Box>
        </Box>
    )
}

export default Advance;